
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/oil-and-gas/products/real-time-oilfield-data-analytics-platforms",
      function () {
        return require("private-next-pages/industries/oil-and-gas/products/real-time-oilfield-data-analytics-platforms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/oil-and-gas/products/real-time-oilfield-data-analytics-platforms"])
      });
    }
  